import React from 'react';

interface IconFormProps {
    iconClasses?: string;
}

const IconForm: React.FC<IconFormProps> = ({ iconClasses }) => {
    return (
        <svg
            width="100%"
            height="100%"
            viewBox="2.33 0.58 9.34 12.84"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={`icon icon-forms ${iconClasses ?? ''}`}
            aria-hidden="true"
        >
          <path d="M9.91797 1.16675H4.08464C3.4403 1.16675 2.91797 1.68908 2.91797 2.33341V11.6667C2.91797 12.3111 3.4403 12.8334 4.08464 12.8334H9.91797C10.5623 12.8334 11.0846 12.3111 11.0846 11.6667V2.33341C11.0846 1.68908 10.5623 1.16675 9.91797 1.16675Z" stroke="currentColor" strokeWidth="1.16667"/>
          <path d="M5.25 4.08325H8.75" stroke="currentColor" strokeWidth="1.16667"/>
          <path d="M5.25 6.41675H8.75" stroke="currentColor" strokeWidth="1.16667"/>
        </svg>
    );
};

export default IconForm;
